// import React, { useState, useCallback, useEffect } from "react";
// import { IoMdAdd } from "react-icons/io";
// import { IoHeartOutline, IoHeartSharp, IoCloseSharp } from "react-icons/io5";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import { BASE_URL, USER_URL } from "../../constant/api";
// import { useSession } from "../../ApiCalls/useSession";
// import AddToCartModel from "../Home/AddToCartModel/AddToCartModel";
// import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

// function OfferProductCard({ products = [], title, bg }) {
//     useSession();
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [quantity, setQuantity] = useState(1);
//     const [wishlist, setWishlist] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();

//     const openModal = useCallback((product) => {
//         setSelectedProduct(product);
//         setIsModalOpen(true);
//     }, []);

//     const closeModal = useCallback(() => {
//         setIsModalOpen(false);
//         setSelectedProduct(null);
//     }, []);

//     useEffect(() => {
//         const getWishlist = async () => {
//             // const token = localStorage.getItem("token");
//             // const sessionId = localStorage.getItem("sessionid");
//             // const headers = token
//             //     ? { Authorization: `Token ${token}` }
//             //     : { "Session-Id": sessionId };

//             try {
//                 const response = await USER_URL.get(`/products/wishlist/`, {
//                     // headers,
//                 });
//                 setWishlist(response.data.items.map((item) => item.product_id));
//             } catch (error) {
//                 console.error("Error fetching wishlist:", error);
//             }
//         };

//         getWishlist();
//     }, []);

//     // Toggle Wishlist
//     const toggleWishlist = async (product_id) => {
//         try {
//             const isWishlisted = wishlist.includes(product_id);
//             // const token = localStorage.getItem("token");
//             // const sessionId = localStorage.getItem("sessionid");
//             // const headers = token
//             //     ? { Authorization: `Token ${token}` }
//             //     : { "Session-Id": sessionId };

//             const res = await USER_URL.post(
//                 `/products/wishlist/`,
//                 { product_id },
//                 // { headers }
//             );

//             setWishlist((prev) =>
//                 isWishlisted
//                     ? prev.filter((id) => id !== product_id)
//                     : [...prev, product_id]
//             );
//         } catch (error) {
//             console.error("Error toggling wishlist:", error);
//         }
//     };

//     const handleDeleteWishlistItem = async (productId) => {
//         // const token = localStorage.getItem("token");
//         // let sessionId = localStorage.getItem("sessionid");

//         // const headers = token
//         //     ? { Authorization: `Token ${token}` }
//         //     : { "Session-Id": sessionId };

//         try {
//             const response = await USER_URL.delete(`/products/wishlist/${productId}/`);

//             if (response.data.Status === "1") {
//                 setWishlist((prev) => prev.filter((id) => id !== productId));
//                 console.log("Item deleted successfully:", response.data);
//             } else {
//                 console.error("Unexpected response:", response.data);
//             }
//         } catch (error) {
//             console.error(`Error deleting item ${productId}:`, error);
//         }
//     };

//     // Function to render the stars
//     const totalStars = 5;
//     const renderStars = (rating) => {
//         const filledStars = Math.floor(rating); // Number of full stars
//         const hasHalfStar = rating % 1 >= 0.5; // For half stars
//         const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0); // Empty stars

//         return (
//             <div className="flex justify-center items-center">
//                 {/* Render Filled Stars */}
//                 {[...Array(filledStars)].map((_, index) => (
//                     <FaStar key={`filled-${index}`} className="text-yellow-500" />
//                 ))}

//                 {/* Render Half Star */}
//                 {hasHalfStar && <FaStarHalfAlt key="half-star" className="text-yellow-500" />}

//                 {/* Render Empty Stars */}
//                 {[...Array(emptyStars)].map((_, index) => (
//                     <FaRegStar key={`empty-${index}`} className="text-gray-400" />
//                 ))}
//             </div>
//         );
//     };

//     return (
//         <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 px-2">
//             {products.length > 0 ? (
//                 products.map((product) => (
//                     <div
//                         key={product.id}
//                         className="w-full md:w-52 flex-none rounded-lg bg-white p-3 border-2 border-gray-300 shadow-md"
//                     >
//                         <div className="flex justify-between items-center text-sm text-brand-light-gray">
//                             <span className="rounded-lg bg-red-600 p-1">
//                                 {product.offer_percent ? `-${product.offer_percent}%` : ""}
//                             </span>

//                             <span
//                                 className="text-red-700 text-2xl cursor-pointer"
//                                 onClick={() =>
//                                     wishlist.includes(product.id)
//                                         ? handleDeleteWishlistItem(product.id) // Call delete function if the product is in the wishlist
//                                         : toggleWishlist(product.id) // Call toggle function to add the product to the wishlist
//                                 }
//                             >
//                                 {wishlist.includes(product.id) ? (
//                                     <IoHeartSharp /> // Filled heart for items in the wishlist
//                                 ) : (
//                                     <IoHeartOutline /> // Outline heart for items not in the wishlist
//                                 )}
//                             </span>
//                         </div>
//                         <Link to={`/product-details/${product.id}`}>
//                             <img
//                                 src={
//                                     product.product_images?.[0]?.image
//                                         ? product.product_images[0].image.startsWith(BASE_URL)
//                                             ? product.product_images[0].image
//                                             : `${BASE_URL}${product.product_images[0].image}`
//                                         : "/images/default-product.png"
//                                 }
//                                 alt={product.name || "Product"}
//                                 className="mb-2 h-32 w-full object-contain my-2 transition transform hover:scale-105"
//                                 onError={(e) => {
//                                     e.target.src = "/images/default-product.png";
//                                 }}
//                             />
//                         </Link>

//                         <div className="flex flex-col items-start gap-2">
//                             <h3 className="font-semibold text-base">
//                                 <Link to={`/product-details/${product.id}`}>
//                                     {product.name || "No Name Available"}
//                                 </Link>
//                             </h3>
//                             <p className="line-clamp-1 text-sm text-gray-500">
//                                 {product.description || "No description available"}
//                             </p>
//                             <div className="flex justify-between items-center w-full ">
//                                 <p className="font-bold text-xs md:text-sm">
//                                     {product.price ? `$${product.price}` : "N/A"}
//                                 </p>
//                                 <div className="flex justify-center items-center gap-1 text-xs md:text-sm">
//                                     {renderStars(product.product_rating)}
//                                     <span className="text-center text-gray-500">{product.product_rating}</span>
//                                 </div>
//                             </div>
//                             <span
//                                 className="bg-[#05BF02] text-xs py-2 rounded-md px-4 w-full text-center text-white cursor-pointer"
//                                 onClick={() => openModal(product)}
//                             >
//                                 Add to Cart
//                             </span>
//                         </div>
//                     </div>
//                 ))
//             ) : (
//                 <p className="text-center text-gray-500">No products available.</p>
//             )}
//             <AddToCartModel
//                 selectedProduct={selectedProduct}
//                 isModalOpen={isModalOpen}
//                 closeModal={closeModal}
//             />
//         </div>
//     );
// }

// export default OfferProductCard;

import React, { useState, useCallback, useEffect } from "react";
import { IoMdAdd } from "react-icons/io";
import { IoHeartOutline, IoHeartSharp, IoCloseSharp } from "react-icons/io5";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useSession } from "../../ApiCalls/useSession";
import AddToCartModel from "../Home/AddToCartModel/AddToCartModel";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

function OfferProductCard({ products = [], title, bg }) {
    useSession();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [wishlist, setWishlist] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const openModal = useCallback((product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    }, []);

    useEffect(() => {
        const getWishlist = async () => {
            try {
                const response = await USER_URL.get(`/products/wishlist/`);
                setWishlist(response.data.items.map((item) => item.product_id));
            } catch (error) {
                console.error("Error fetching wishlist:", error);
            }
        };

        getWishlist();
    }, []);

    const toggleWishlist = async (product_id) => {
        try {
            const isWishlisted = wishlist.includes(product_id);
            const res = await USER_URL.post(
                `/products/wishlist/`,
                { product_id }
            );

            setWishlist((prev) =>
                isWishlisted
                    ? prev.filter((id) => id !== product_id)
                    : [...prev, product_id]
            );
        } catch (error) {
            console.error("Error toggling wishlist:", error);
        }
    };

    const handleDeleteWishlistItem = async (productId) => {
        try {
            const response = await USER_URL.delete(`/products/wishlist/${productId}/`);
            if (response.data.Status === "1") {
                setWishlist((prev) => prev.filter((id) => id !== productId));
            }
        } catch (error) {
            console.error(`Error deleting item ${productId}:`, error);
        }
    };

    const renderStars = (rating) => {
        const filledStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - filledStars - (hasHalfStar ? 1 : 0);

        return (
            <div className="flex justify-center items-center">
                {[...Array(filledStars)].map((_, index) => (
                    <FaStar key={`filled-${index}`} className="text-yellow-500" />
                ))}
                {hasHalfStar && <FaStarHalfAlt key="half-star" className="text-yellow-500" />}
                {[...Array(emptyStars)].map((_, index) => (
                    <FaRegStar key={`empty-${index}`} className="text-gray-400" />
                ))}
            </div>
        );
    };

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 px-2">
            {products.length > 0 ? (
                products.map((product) => (
                    <div
                        key={product.id}
                        className="flex flex-col hover:scale-105 transition-transform ease-in-out duration-300 rounded-lg bg-white p-3 border-2 border-gray-300 shadow-md h-full"
                    >
                        <div className="flex justify-between items-center text-sm text-brand-light-gray">
                            {(product.offer_percent || product.offer_percent === null) && (
                                <span className="">
                                    {product.offer_percent ? <span className="bg-red-600 rounded-lg p-1 px-2">{product.offer_percent}%</span> : <span className="bg-transparent"></span>}
                                </span>
                            )}
                            <span
                                className="text-red-700 text-2xl cursor-pointer"
                                onClick={() =>
                                    wishlist.includes(product.id)
                                        ? handleDeleteWishlistItem(product.id)
                                        : toggleWishlist(product.id)
                                }
                            >
                                {wishlist.includes(product.id) ? (
                                    <IoHeartSharp />
                                ) : (
                                    <IoHeartOutline />
                                )}
                            </span>
                        </div>
                        <Link to={`/product-details/${product.id}`} className="flex-grow">
                            <img
                                src={
                                    product.product_images?.[0]?.image
                                        ? product.product_images[0].image.startsWith(BASE_URL)
                                            ? product.product_images[0].image
                                            : `${BASE_URL}${product.product_images[0].image}`
                                        : "/images/default-product.png"
                                }
                                alt={product.name || "Product"}
                                className="mb-2 h-32 w-full object-contain my-2 transition transform"
                                onError={(e) => {
                                    e.target.src = "/images/default-product.png";
                                }}
                            />
                        </Link>

                        <div className="flex flex-col flex-grow">
                            <div className="mb-2">
                                <h3 className="font-semibold text-base line-clamp-2 h-12 hover:text-green-500">
                                    <Link to={`/product-details/${product.id}`}>
                                        {product.name || "No Name Available"}
                                    </Link>
                                </h3>
                                <p className="line-clamp-2 text-sm text-gray-500 h-10">
                                    {product.description || "No description available"}
                                </p>
                            </div>
                            
                            <div className="mt-auto">
                                <div className="flex justify-between items-center w-full mb-2">
                                    <p className="font-bold text-sm">
                                        {product.price ? `${product.currency_symbol}${product.price}` : "N/A"}
                                    </p>
                                    <div className="flex items-center gap-1 text-xs">
                                        {renderStars(product.product_rating)}
                                        <span className="text-gray-500">{product.product_rating}</span>
                                    </div>
                                </div>
                                <button
                                    className="bg-[#05BF02] text-xs py-2 rounded-md px-4 w-full text-center text-white cursor-pointer hover:bg-[#049a02] transition-colors"
                                    onClick={() => openModal(product)}
                                >
                                    Add to Cart
                                </button>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <p className="text-center text-gray-500 col-span-full">No products available.</p>
            )}
            <AddToCartModel
                selectedProduct={selectedProduct}
                isModalOpen={isModalOpen}
                closeModal={closeModal}
            />
        </div>
    );
}

export default OfferProductCard;
